import React from "react";
import "./StepThree.css";
import { Avatar, Button, Typography, useMediaQuery } from "@mui/material";
import { perspectiveData } from "./perspectiveData";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowUp } from "@fortawesome/free-solid-svg-icons";
import { stepThreeData } from "../stepsData";

const StepThree = () => {
  // Screen Size
  const isMediumScreen = useMediaQuery(" (max-width:768px) ");
  return (
    <>
      <div>
        <section className="step-three mt-2 ">
          <Typography
            sx={{ fontSize: "23.8532px", fontFamily: "'Archivo', sans-serif" }}
            className="archivo fw-bold"
          >
            {stepThreeData[0].stepThreeHeading}
          </Typography>
          <div>
            <Typography
              sx={{
                fontSize: 16,
                lineHeight: "24px",
                fontFamily: "'Archivo', sans-serif",
              }}
              className="archivo mt-2"
            >
              {stepThreeData[0].paraOne}
            </Typography>
          </div>
          <div>
            <ul
              style={{ listStyle: "disc", fontSize: 16, color: "#1f1f1f" }}
              className=" archivo"
            >
              <li>
                <strong>Credit Score Requirements: </strong>
                {stepThreeData[0].creditScoreRequirements}
              </li>
              <li>
                <strong>Loan Amounts and Terms: </strong>{" "}
                {stepThreeData[0].loanAmountsAndTerms}
              </li>
              <li>
                <strong>Funding Speed </strong> {stepThreeData[0].fundingSpeed}
              </li>
              <li>
                <strong>Co-signed or Secured Loans: </strong>{" "}
                {stepThreeData[0].securedLoans}
              </li>
            </ul>
          </div>
        </section>
        <section className="mt-4 mb-2">
          <div className="d-flex align-items-center gap-3 mb-2">
            <img
              src="/Assets/Images/Logo.webp"
              loading="lazy"
              alt="logo"
              className="perspective_img"
            />
            <Typography
              sx={{
                fontSize: 16,
                lineHeight: "24px",
                color: "#1f1f1f",
                fontFamily: "'Archivo', sans-serif",
                fontWeight: 700,
              }}
            >
              Minemi Expert Take:
            </Typography>
          </div>
          <Typography
            sx={{
              fontSize: 20,
              lineHeight: "26px",
              color: "#59266D",
              fontWeight: 400,
              fontFamily: "'Archivo', sans-serif",
            }}
          >
            Expert take: Why research lenders?
          </Typography>
          <div className="perspective_box d-flex flex-column flex-md-row gap-3 p-4 mt-3 rounded-2">
            <div className="perspective_content d-flex flex-column  justify-content-center align-items-center ps-3 py-0 ">
              <Typography
                sx={{
                  fontSize: "16px",
                  lineHeight: "24px",
                  // color: "#ffffff",
                  color: "#000",
                  fontWeight: 500,
                  fontFamily: "'Archivo', sans-serif",
                }}
              >
                <span
                  style={{
                    fontSize: "16px",
                    lineHeight: "24px",
                    // color: "#fff",
                    color: "#000",
                  }}
                  className="archivo"
                >
                  "
                </span>
                {perspectiveData[0].paraOne}
                <span
                  style={{
                    fontSize: "16px",
                    lineHeight: "24px",
                    // color: "#fff",
                    color: "#000",
                  }}
                  className="archivo"
                >
                  "
                </span>
              </Typography>
              {/* <Typography
                  sx={{
                    fontSize: "16px",
                    // color: "#ffffff",
                    color: "#000",
                    fontWeight: 500,
                    lineHeight: "24px",
                    letterSpacing: "normal",
                    fontFamily: "'Archivo', sans-serif",
                    className: "mt-4",
                  }}
                >
                  {perspectiveData[0].paraTwo}
                  <span
                    style={{
                      fontSize: "16px",
                      lineHeight: "24px",
                      // color: "#fff",
                      color: "#000",
                    }}
                    className="archivo"
                  >
                    "
                  </span>
                </Typography> */}
            </div>
            <div className=" d-flex flex-row flex-md-column align-items-center align-items-md-end">
              <Avatar
                src=""
                alt=""
                sx={{
                  width: isMediumScreen ? 50 : 111,
                  height: isMediumScreen ? 50 : 111,
                }}
              />
              <Typography
                sx={{
                  fontSize: "13px",
                  lineHeight: "20px",
                  fontWeight: 500,
                  // color: "#fff",
                  color: "#000",
                  fontFamily: "'Archivo',sans-serif",
                }}
                className=" mt-md-3 ps-3"
              >
                {perspectiveData[0].name}, {perspectiveData[0].position}
              </Typography>
            </div>
          </div>
        </section>
      </div>
      <Button
        sx={{
          textTransform: "none",
          margin: "0px",
          fontSize: 16,
          fontFamily: "'Archivo', sans-serif",
        }}
        onClick={() => {
          window.scroll(0, 0);
        }}
        className="d-flex algin-items-center archivo mt-2"
      >
        <FontAwesomeIcon icon={faArrowUp} /> &nbsp; Back To Top
      </Button>
    </>
  );
};

export default StepThree;
